import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Header from "../components/header/Header";
import Footer from "../components/footer";
import Breadcrumb from "../components/breadcrumb";
import Review from "../components/aboutPage/Review";
import Gotop from "../components/gotop";
import BannerCounter from "../components/aboutPage/BannerCounter";
import { Link } from "react-router-dom";
import img1 from "../assets/images/job/work-icon-1.jpg";
import img2 from "../assets/images/job/work-icon-2.jpg";
import img3 from "../assets/images/job/work-icon-3.jpg";
import Iconbox3 from "../components/aboutPage/Iconbox3";
import Testimonial from "../components/aboutPage/Testimonial";
import dataTestimonials from "../assets/fakeData/dataTestimonials";
import Partner from "../components/aboutPage/Partner";

AboutUs.propTypes = {};

function AboutUs(props) {
  return (
    <>
      <Header />
      <Breadcrumb title="About Talsolution" />
      <Review />
      <BannerCounter />
      <section className="wd-iconbox style-3 inner-iconbox-section">
        <div className="tf-container">
          <div className="title-iconbox style-3 stc">
            <h4>How Talsolution Works</h4>
            <p>
              Your trusted partner in connecting global technical talent with US opportunities
            </p>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="group-col-3">
                <div className="tf-iconbox style-3 cl3 stc2">
                  <div className="box-header">
                    <div className="img1">
                      <img src={img1} alt="img" />
                    </div>
                  </div>
                  <div className="box-content">
                    <h6 className="box-title">
                      <Link to="/careers">Create Your Profile</Link>
                    </h6>
                    <p>
                      Build your professional profile highlighting your technical skills, 
                      experience, and career aspirations. Our platform showcases your 
                      expertise to top US employers.
                    </p>
                    <button>
                      Get Started&nbsp;
                      <span className="icon-arrow-right2" />
                    </button>
                  </div>
                </div>
                <div className="tf-iconbox style-3 cl3 stc2">
                  <div className="box-header">
                    <div className="img1">
                      <img src={img2} alt="img" />
                    </div>
                  </div>
                  <div className="box-content">
                    <h6 className="box-title">
                      <Link to="/careers">Match with Opportunities</Link>
                    </h6>
                    <p>
                      Our team connects you with positions that align with your skills 
                      and career goals at leading US tech companies seeking global talent.
                    </p>
                    <button>
                      View Positions&nbsp;
                      <span className="icon-arrow-right2" />
                    </button>
                  </div>
                </div>
                <div className="tf-iconbox style-3 cl3 stc2">
                  <div className="box-header">
                    <div className="img1">
                      <img src={img3} alt="img" />
                    </div>
                  </div>
                  <div className="box-content ">
                    <h6 className="box-title">
                      <Link to="/careers">
                        Start Your Journey
                      </Link>
                    </h6>
                    <p>
                      From application to onboarding, we provide comprehensive support 
                      including visa guidance, interview prep, and smooth integration 
                      with your new team.
                    </p>
                    <button>
                      Learn More&nbsp;
                      <span className="icon-arrow-right2" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Iconbox3 />
      <Testimonial data={dataTestimonials} />
      <Partner />
      <section className="wd-banner-CTA">
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12  wow fadeInUp">
              <div className="group-banner-CTA">
                <h3>Ready to Take Your Career Global?</h3>
                <p>
                  Join thousands of technical professionals who've found their dream 
                  roles at leading US companies through Talsolution.
                </p>
                <div className="group-btn">
                  <button className="tf-btn">Browse Positions</button>
                  <button className="tf-btn">Contact Us</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Gotop />
    </>
  );
}

export default AboutUs;
